<template>
  <div class="w-full py-6 box-border relative">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
      维度与评分
    </header>
    <div class="pl-6 pr-4 mt-2 box-border">
      <div class="mb-2">
        <p class="text-medium text-theme-black-850 leading-24">
          可应用于在线测评和在线考试场景，轻松搭建在线测评系统。
        </p>
      </div>
      <div class="mb-2">
        <p class="mb-1 text-medium text-theme-black-850 leading-24 font-semibold">
          1.设置题目分值
        </p>
        <p class="text-medium text-theme-black-850 leading-24">
          设置测评问题，添加题目选项分值；
        </p>
        <span
          class="select-none cursor-pointer text-medium text-theme leading-24"
          @click="openDialog"
        >
          添加教程
        </span>
      </div>
      <div class="mb-2">
        <p class="mb-1 text-medium text-theme-black-850 leading-24 font-semibold">
          2.维度设置和评分
        </p>
        <p class="text-medium text-theme-black-850 leading-24">
          构建不同的测评维度，关联测评题目，系统自动计算维度总分，均分。
        </p>
      </div>
      <div class="mb-2">
        <p class="mb-1 text-medium text-theme-black-850 leading-24 font-semibold">
          3.标准分和权重
        </p>
        <p class="text-medium text-theme-black-850 leading-24">
          划定一个标准分，测评者可以比较自己得分与标准分的差距；可设置各个维度的权重，系统按权重计算总得分。
        </p>
      </div>
      <div class="mb-2">
        <p class="mb-1 text-medium text-theme-black-850 leading-24 font-semibold">
          4.测评结果输出
        </p>
        <p class="text-medium text-theme-black-850 leading-24">
          系统根据总得分、各维度得分，输出对应的测评结果。
        </p>
      </div>
      <div>
        <p class="mb-1 text-medium text-theme-black-850 leading-24 font-semibold">
          5.测评数据与报告，一秒呈现
        </p>
        <p class="text-medium text-theme-black-850 leading-24">
          一秒呈现测评数据、统计、结果、建议；并支持柱状图、饼状图等图形化展示。
        </p>
      </div>
    </div>
    <div class="absolute bottom-0 w-full h-px pl-6 pr-4 box-border">
      <div class="w-full f-full border-b border-solid border-theme-gray" />
    </div>
  </div>
</template>

<script>
import { createPopup } from '@/assets/js/factory'
import EvalIllustDialog from './EvalIllustDialog'

export default {
  name: 'AsideDimensionScore',
  methods: {
    openDialog() {
      createPopup(EvalIllustDialog, {});
    }
  }
}
</script>